import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrganizationServices } from 'app/main/shared/services/organization.services';
import { LocalUserService } from 'app/main/shared/services/localUser';

@Component({
  selector: 'user-selecter',
  templateUrl: './user-selecter.component.html',
  styleUrls: ['./user-selecter.component.scss']
})
export class UserSelecterComponent implements OnInit {

  @Input()
  type: 'assign' | 'shared' = 'shared'
  @Input() task: any;
  @Input() project: any;
  @Input() isSave: boolean = false;

  @Output()
  select: EventEmitter<any> = new EventEmitter();
  @Output()
  selectedUsers: EventEmitter<any> = new EventEmitter();
  allUsers = [];
  orgId: string;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  constructor(
    private organizationServices: OrganizationServices,
    private localUser: LocalUserService
  ) {

  }

  ngOnChanges() {
    if (this.isSave) {
      this.getAllUsers()
    }
    this.setSelected();
  }

  ngOnInit() {
    this.orgId = this.localUser.getOrganizationId();
    this.getAllUsers()

    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Users",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class"
    };
  }
  onItemSelect($event) {
    this.select.emit(this.selectedItems);
  }
  OnItemDeSelect($event) {
    this.select.emit(this.selectedItems);
  }
  onSelectAll(items: any) {
    this.select.emit(this.selectedItems);
  }
  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.select.emit(this.selectedItems);
  }

  getAllUsers() {
    this.organizationServices.getUsersInOrganization(this.orgId)
      .subscribe(page => {
        this.allUsers = page;
        this.selectedUsers.emit(page)
        if (page && page.length) {
          this.dropdownList = page.map(item => {
            return {
              id: item.id,
              itemName: `${item.first_name} ${item.last_name} (${item.role})`
            }
          });
          this.setSelected();
        }
        this.isSave = false
      });
  }

  setSelected() {

    if (!this.allUsers && !this.allUsers.length) return;

    this.selectedItems = [];

    if (this.type !== 'assign') {
      if (!this.project || this.project === null || this.project === '' || this.project === undefined) { return; }
      if (!this.project.shared_with && !this.project.shared_with.length) { return; }

      this.project.shared_with.forEach(userId => {
        let user = this.allUsers.find(u => u.id === userId);
        if (user) {
          this.selectedItems.push({
            id: user.id,
            itemName: `${user.first_name} ${user.last_name}`
          })
        };
      })
    } else {
      if (!this.task.assigned_to || !this.task.assigned_to && !this.task.assigned_to.length) return;

      this.task.assigned_to.forEach(userId => {
        let user = this.allUsers.find(u => u.id === userId);
        if (user) {
          this.selectedItems.push({
            id: user.id,
            itemName: `${user.first_name} ${user.last_name}`
          })
        };
      })
    }
  }

}






// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/user-selecter/user-selecter.component.ts